/**
 * Вікно інтерфейсу для скасування (audit-undo.md, розд. 4.2; UX-14): тост 5 с, `Ctrl+Z` — 60 с. Це
 * `ttlMs` блоку `undo`. Окремий модуль без zod: веб бере його підшляхом, корінь контрактів тягне
 * zod у чанки.
 */
export const UNDO_TTL_MS = 60_000;
